import { IQuick3DCamera } from '../../quick3d-camera-interface';
import { IZoomControl, IZoomArguments } from './zoom-control-interface';

/**
 * projection mode agnostic camera zoomer
 *
 * calculation is final zoom = current zoom / (1 + (direction * step))
 *
 * [live demo](https://threejs.org/examples/misc_controls_trackball.html)
 *
 * example:
 * ```typescript
 * const camera = new Quick3DOrthographicCamera();
 * const zoomControl = new GenericZoomControl();
 * // zoom out ~10% of current zoom level
 * zoomControl.zoom(camera, {zoomDirection: 1, zoomStep: 0.1}); // zoom is now 0.90909
 * // zoom out ~100% of current zoom level
 * zoomControl.zoom(camera, {zoomDirection: 1, zoomStep: 1});
 * // reset zoom
 * camera.zoom = 1;
 * // zoom in ~100% of current zoom level
 * zoomControl.zoom(camera, {zoomDirection: -1, zoomStep: 0.5});// zoom is now 2
 * ```
 */
export class GenericZoomControl implements IZoomControl {
    public constructor() {}

    /**
     * safe values of zoomStep for zooming out are in the range [0, Infinity)
     *
     * safe values of zoomStep for zooming in are in the range [0, 1)
     * @param zoomArguments.zoomDirection defaults to 1
     * @param zoomArguments.zoomStep defaults to 0.1
     */
    public zoom(
        camera: IQuick3DCamera,
        zoomArguments: IZoomArguments = {}
    ): void {
        const { zoomDirection = 1, zoomStep = 0.1 } = zoomArguments;

        const currZoom = camera.zoom;
        const zoomModifier = 1.0 + zoomDirection * zoomStep;
        camera.zoom = currZoom / zoomModifier;
        camera.updateProjectionMatrix();
    }
}
